import { render } from "./Wave.vue?vue&type=template&id=1aac0b19&scoped=true"
import script from "./Wave.vue?vue&type=script&lang=ts"
export * from "./Wave.vue?vue&type=script&lang=ts"

import "./Wave.vue?vue&type=style&index=0&id=1aac0b19&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1aac0b19"

export default script